var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { memo } from 'react';
import { useToggle } from '@hn-front/utils';
import { ViewDeletedStudentsButton } from '../Buttons';
import { Body } from './Common';
import { DeletedStudentRow } from './Rows/DeletedStudentsRows';
var ViewDeletedStudentsRow = styled.div.withConfig({ displayName: "ViewDeletedStudentsRow", componentId: "sc-nm6jdi" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  align-self: stretch;\n\n  padding: 16px 32px;\n\n  z-index: 0;\n  box-shadow: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  align-self: stretch;\n\n  padding: 16px 32px;\n\n  z-index: 0;\n  box-shadow: ", ";\n"])), function (_a) {
    var open = _a.open;
    return open ? '0px 16px 16px -16px rgba(0,0,0,0.1); ' : 'unset';
});
var DeletedStudentsTable = memo(function (_a) {
    var students = _a.students, onRecover = _a.onRecover;
    var _b = useToggle(), isOpen = _b.isToggled, onToggle = _b.toggle;
    if (students.length === 0) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsx(ViewDeletedStudentsRow, __assign({ open: isOpen }, { children: _jsx(ViewDeletedStudentsButton, { isOpen: isOpen, onClick: onToggle }, void 0) }), void 0), isOpen && (_jsx(Body, { children: students.map(function (_a) {
                    var id = _a.id, name = _a.name;
                    return (_jsx(DeletedStudentRow, { id: id, name: name, onRecover: onRecover }, id));
                }) }, void 0))] }, void 0));
});
export { DeletedStudentsTable };
var templateObject_1;
